(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/casino-react/casino-store/assets/javascripts/store.js') >= 0) return;  svs.modules.push('/components/casino-react/casino-store/assets/javascripts/store.js');
"use strict";


const {
  configureStore
} = RTK;
const {
  searchApi,
  favoritesApi
} = svs.components.casino_react.casinoStore.endpoints;
const {
  lastSearchedListenerMiddleware
} = svs.components.casino_react.casinoStore.middlewares;
const {
  lastSearchedReducer
} = svs.components.casino_react.casinoStore.reducers;
const store = configureStore({
  reducer: {
    [searchApi.reducerPath]: searchApi.reducer,
    [favoritesApi.reducerPath]: favoritesApi.reducer,
    lastSearched: lastSearchedReducer
  },
  middleware: getDefaultMiddleware => [lastSearchedListenerMiddleware.middleware, ...getDefaultMiddleware(), searchApi.middleware, favoritesApi.middleware]
});
setGlobal('svs.components.casino_react.casinoStore.store', store);

 })(window);